import ErrorPage from './ErrorPage';
import FormGroup from './FormGroup';
import FormTitle from './FormTitle';
import LoadingIndicator from './LoadingIndicator';
import PageContainer from './PageContainer';
import PermissionDropdown from './PermissionDropdown';
import RichTextField from './RichTextField';
import SaveControls from './SaveControls';
import SelectWithDisabled from './SelectWithDisabled';
import ValidationErrors from './ValidationErrors';

export const components = {
    ErrorPage,
    FormGroup,
    FormTitle,
    LoadingIndicator,
    PageContainer,
    PermissionDropdown,
    RichTextField,
    SaveControls,
    SelectWithDisabled,
    ValidationErrors,
};
